export const DEFAULT = {
  LOAD_LIMIT: 5,
  MAX_LOAD_IMAGES: 3,
  MIN_LOAD_IMAGES: 2,
  FEE: 2,
  DEFAULT_SLICE_ADDRESS: 9,
  MIN_RUB: 500,
  MIN_USDT: 3,
  MAX_RUB: 100000,
  MAX_USDT: 1000,
  MIN_WITHDRAW_USDT: 10,
  COMISSION_PERCENT_RUB_ALTUN: 2,
  COMISSION_PERCENT_RUB_MY: 3,
  COMISSION_USDT: 3,
  RECOMEND_AMOUNT: 5000,
  REFERRAL_LEVEL_1: 0.5,
  REFERRAL_LEVEL_2: 0.1,
  
  SEARCH_REF_CODE: "refCode",
};
